import {Component, Injector} from "@angular/core";
import {ConfigurationService, provideSearchModel} from "@fedeltapointofsale/data-client";
import {BIPageSearchModel} from "../bi-page-search.model";
import {AbstractSelectNavComponent} from "../../../framework/entity/nav/select-nav/abstract-select-nav.component";
import {Router} from "@angular/router";
import {BIPageSearchPageComponent} from "../bi-page-search-page/bi-page-search-page.component";
import {BIPageData} from "../bi-page.data";
import {ServerAuth} from "../../../config";
import {FUISelectAction, FUIOptionMetaData, FUIIcon} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-bi-page-select-nav",
    templateUrl: "../../../framework/entity/nav/select-nav/select-nav.component.html",
    providers: [
        provideSearchModel(BIPageSearchModel)
    ]
})
export class BiPageSelectNavComponent extends AbstractSelectNavComponent<BIPageSearchModel> {
    private publicAccess: boolean = false;

    constructor(model: BIPageSearchModel,
                private router: Router,
                private configService: ConfigurationService,
                injector: Injector) {
        super(model, injector, "id", "name");

        this.label = "wbo.bi.button.changePage";
        this.extendedSearchComponent = BIPageSearchPageComponent;
        this.showAddOption = false;

        this.configService.getBoolean(ServerAuth.PUBLISH_BI_DASHBOARD).then((authorised) => {
            this.publicAccess = authorised;
        });

        this.getOptionMetaData = (option: BIPageData) => new FUIOptionMetaData({
            icon: new FUIIcon({
                icon: option.pageType === BIPageData.PAGE_TYPE_DASHBOARD ? "column_chart" : "grid",
                height: 26,
                width: 26,
                color: option.id < 0 || (option.recUserId == null && !this.publicAccess) ? "#8f9092" : "#225087"
            }),
            groupHeading: option.id < 0 ? "wbo.bi.heading.systemDashboards" : "wbo.bi.heading.customDashboards"
        });

        this.actions = [
            {
                name: "dashboard",
                title: "wbo.bi.option.addDashboard",
                icon: "add-chart",
                iconHeight: 26,
                iconWidth: 26
            }, {
                name: "pivotgrid",
                title: "wbo.bi.option.addPivotGrid",
                icon: "add-grid",
                iconHeight: 26,
                iconWidth: 26
            }
        ];
    }

    override onSelect(option: BIPageData) {
        if (option.pageType === BIPageData.PAGE_TYPE_DASHBOARD) {
            this.router.navigate(["/main/dashboard/" + option.id]);
        } else if (option.pageType === BIPageData.PAGE_TYPE_PIVOT_GRID) {
            this.router.navigate(["/main/pivot/" + option.id]);
        }
    }

    override onAction(action: FUISelectAction) {
        if (action.name === "dashboard") {
            this.router.navigate(["/main/dashboard-edit/new"]);
        } else if (action.name === "pivotgrid") {
            this.router.navigate(["/main/pivot-edit/new"]);
        }
    }
}
